require('../../modules/es6.object.assign');
module.exports = require('../../modules/$.core').Object.assign;


//////////////////
// WEBPACK FOOTER
// ./~/react-async-script/~/core-js/library/fn/object/assign.js
// module id = 697
// module chunks = 0